import { useState, useEffect, useRef } from "react";
import ReactHtmlParser from "html-react-parser";
import moment from "moment";
import {
    BASE_URL,
} from "../../../env";

import { useNavigate } from "react-router-dom";
import Layout from "../../../components/layouts/Layout";
import UserDetailReview from "../../../components/user-detail/UserDetailReview";
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import '@progress/kendo-theme-default/dist/all.css';

function ViewPbsPlansHistory() {

    const navigate = useNavigate();

    // check if pbs plan id exists or not 
    const localStoragepbsPlan = localStorage.getItem("pbsPlanHistoryItemData");
    let parsedHistoryPbsPlan = null;
    console.log("🚀 ~ ViewPbsPlansHistory ~ parsedHistoryPbsPlan:", parsedHistoryPbsPlan)

    if (localStoragepbsPlan === null) {
        navigate("/pbs-plans-history");
    } else {
        try {
            parsedHistoryPbsPlan = JSON.parse(localStoragepbsPlan);
        } catch (error) {
            console.error("Invalid JSON in localStorage", error);
            navigate("/pbs-plans-history");
        }
    }


    // Get user record
    const storedUserDetails = localStorage.getItem("profileUserDetails");
    const userData = storedUserDetails ? JSON.parse(storedUserDetails) : null;

    // PBS Plan Detail State
    const [pbsPlansDetail, setPbsPlansDetail] = useState(null);
    const [pbsPlansHistoryDetail, setPbsPlansHistoryDetail] = useState(null);
    console.log("🚀 ~ ViewPbsPlansHistory ~ pbsPlansHistoryDetail:", pbsPlansHistoryDetail)

    useEffect(() => {
        if (parsedHistoryPbsPlan) {
            setPbsPlansDetail(parsedHistoryPbsPlan);
        }
    }, [parsedHistoryPbsPlan]);

    // Safe HTML parser
    const parseHTML = (html) => ReactHtmlParser(html || "");

    //Export to pdf
    const pdfExportComponent = useRef(null);
    const [showInPrint, setShowInPrint] = useState(false);
    const exportPDF = () => {
        if (pdfExportComponent.current) {
            setShowInPrint(true);
            setTimeout(() => {
                pdfExportComponent.current.save();
            }, 100);
            setTimeout(() => {
                setShowInPrint(false);
            }, 1000);
        }
    };

    // ⏳ Prevent rendering until data is loaded
    if (!pbsPlansDetail) {
        return (
            <Layout pageTitleText="PBS Plans - History">
                <p className="text-center mt-5">Loading...</p>
            </Layout>
        );
    }

    return (
        <>

            <Layout pageTitleText="PBS Plans - History">
                <UserDetailReview
                    getUserRecord={userData}
                    avatarActionButtons={false}
                    viewNotes={false}
                    profileDetail={false}
                    horizontalDetail={true}
                    launchVideoButtons={true}
                />

                <div className="viewEditorWrapper">
                    <div className="mainContent mt-3 pt-4">
                        {/* TOP SECTION */}
                        <header className="mainContentHeader">
                            <div className="usersNameInfo">
                                <div className="contentBox">
                                    <span className="isReviewed">
                                        {
                                            pbsPlansDetail?.isReviewed ? "✅ Marked as Reviewed" : "❌ Not Marked as Reviewed"
                                        }
                                    </span>
                                </div>
                            </div>

                        </header>

                        {/* USER INFO BAR */}
                        <header className={`mainContentHeader ${showInPrint ? "hiddenDiv" : ""}`}>
                            <div className="usersNameInfo">
                                <span className="userImage">
                                    <img
                                        src={`${BASE_URL}${pbsPlansDetail?.staffId?.profile_picture_url}`}
                                        alt={pbsPlansDetail?.staffId?.name}
                                    />
                                </span>
                                <div className="contentBox">
                                    <p className="m-0">
                                        <strong>{pbsPlansDetail?.staffId?.name}</strong>
                                        <small>
                                            {moment(pbsPlansDetail?.updatedAt).format(
                                                "DD/MM/YYYY / hh:mm:ss A"
                                            )}
                                        </small>
                                        <small>
                                            Due Date:{" "}
                                            {moment(pbsPlansDetail?.completionDate).format(
                                                "DD/MM/YYYY"
                                            )}
                                        </small>
                                    </p>
                                </div>
                            </div>

                            <div>
                                <span className="btn btn-sm btn-outline-primary"
                                    onClick={exportPDF}
                                >Export to PDF</span>

                                &nbsp;
                                <span
                                    className="btn btn-sm btn-primary"
                                    onClick={() => navigate("/pbs-plans-history")}
                                >
                                    Back to PBS Plans History
                                </span>
                            </div>
                        </header>

                        {/* CONTENT SECTIONS */}

                        <PDFExport
                            ref={pdfExportComponent}
                            paperSize={["900pt", "900pt"]}
                            margin={20}
                            fileName={`PBS Plan`}
                        >

                            <header className={`mainContentHeader ${showInPrint ? "" : "hiddenDiv"}`}>
                                <div className="usersNameInfo">
                                    <span className={`userImage ${showInPrint ? "hiddenDiv" : ""}`}>
                                        <img
                                            src={`${BASE_URL}${pbsPlansDetail?.staffId?.profile_picture_url}`}
                                            alt={pbsPlansDetail?.staffId?.name}
                                        />
                                    </span>
                                    <div className="contentBox">
                                        <p className="m-0">
                                            <strong>{pbsPlansDetail?.staffId?.name}</strong>
                                            <small>
                                                {moment(pbsPlansDetail?.updatedAt).format(
                                                    "DD/MM/YYYY / hh:mm:ss A"
                                                )}
                                            </small>
                                            <small>
                                                Due Date:{" "}
                                                {moment(pbsPlansDetail?.completionDate).format(
                                                    "DD/MM/YYYY"
                                                )}
                                            </small>
                                        </p>
                                    </div>
                                </div>
                                <div className="usersNameInfo">
                                    <div className="contentBox">
                                        <span className="isReviewed">
                                            {
                                                pbsPlansDetail?.isReviewed ? "✔ Marked as Reviewed" : "✗ Not Marked as Reviewed"
                                            }
                                        </span>
                                    </div>
                                </div>

                            </header>

                            <div className="viewEditorContent">

                                {/* All about me (TITLE) */}
                                <div className="sectionWrapper">
                                    <div className="sectionContent pbsFieldWrapper">
                                        <header className="alert alert-dark mobpBg">
                                            <h3>All about me</h3>
                                        </header>
                                        <div className="mobpContentBg p-3">
                                            {parseHTML(pbsPlansDetail?.aboutPlan)}
                                        </div>
                                    </div>
                                </div>



                                {/* Aim of Positive Behaviour Support Plan */}
                                <div className="sectionWrapper">
                                    <div className="sectionContent pbsFieldWrapper">
                                        <header className="alert alert-dark mobpBg">
                                            <h3>Aim of Positive Behaviour Support Plan</h3>
                                        </header>
                                        <div className="mobpContentBg p-3">
                                            {parseHTML(pbsPlansDetail?.aimOfPositiveBehaviourPlan)}
                                        </div>
                                    </div>
                                </div>



                                {/* Setting Events (Slow Triggers) */}
                                <div className="sectionWrapper">
                                    <div className="sectionContent pbsFieldWrapper">
                                        <header className="alert alert-dark mobpBg">
                                            <h3>Setting Events (Slow Triggers)</h3>
                                        </header>
                                        <div className="mobpContentBg p-3">
                                            {parseHTML(pbsPlansDetail?.settingEventsPlan)}
                                        </div>
                                    </div>
                                </div>



                                {/* Discriminative Stimuli (Fast Triggers) */}
                                <div className="sectionWrapper">
                                    <div className="sectionContent pbsFieldWrapper">
                                        <header className="alert alert-dark mobpBg">
                                            <h3>Discriminative Stimuli (Fast Triggers)</h3>
                                        </header>
                                        <div className="mobpContentBg p-3">
                                            {parseHTML(pbsPlansDetail?.discriminativeStimuliPlan)}
                                        </div>
                                    </div>
                                </div>



                                {/* Behaviour of Concern */}
                                <div className="sectionWrapper">
                                    <div className="sectionContent pbsFieldWrapper">
                                        <header className="alert alert-dark mobpBg">
                                            <h3>Behaviour of Concern</h3>
                                        </header>
                                        <div className="mobpContentBg p-3">
                                            {parseHTML(pbsPlansDetail?.behaviourOfConcernPlan)}
                                        </div>
                                    </div>
                                </div>




                                {/* Management of Behavioural Presentation */}
                                <div className="sectionWrapper">
                                    <div className="sectionContent pbsFieldWrapper">
                                        <header className="alert alert-dark mobTitle border-bottom-0">
                                            <h3>Management of Behavioural Presentation<br />
                                                Primary Prevention – Proactive</h3>
                                        </header>
                                        <header className="alert alert-dark mobpBg">
                                            <h3>When I am calm and at baseline</h3>
                                        </header>
                                        <div className="mobpContentBg p-3">
                                            {parseHTML(pbsPlansDetail?.managementOfBehaviorPlan)}
                                        </div>
                                    </div>
                                </div>




                                {/* Reducing likelihood of target behaviour occurring  */}
                                <div className="sectionWrapper">
                                    <div className="sectionContent pbsFieldWrapper">
                                        <header className="alert alert-dark cleanBg">
                                            <h3>Reducing likelihood of target behaviour occurring </h3>
                                        </header>
                                        <div className="cleanBg p-3">
                                            {parseHTML(pbsPlansDetail?.reducingLikeliHood)}
                                        </div>
                                    </div>
                                </div>


                                <div className="sectionWrapper">
                                    <div className="sectionContent pbsFieldWrapper">
                                        <header className="alert alert-dark spBg">
                                            <h3>Secondary Prevention<br />
                                                Indicators I am moving away from baseline</h3>
                                        </header>
                                        <div className="spContentBg p-3">
                                            {parseHTML(pbsPlansDetail?.secondaryPrevention)}
                                        </div>
                                    </div>
                                </div>


                                {/* Things to do when I display amber behaviours  */}
                                <div className="sectionWrapper">
                                    <div className="sectionContent pbsFieldWrapper">
                                        <header className="alert alert-dark cleanBg">
                                            <h3>Things to do when I display amber behaviours</h3>
                                        </header>
                                        <div className="cleanBg p-3">
                                            {parseHTML(pbsPlansDetail?.thingsToDisplayAmberBehavior)}
                                        </div>
                                    </div>
                                </div>

                                {/* Reactive Strategies */}
                                <div className="sectionWrapper">
                                    <div className="sectionContent pbsFieldWrapper">
                                        <header className="alert alert-dark rsBg">
                                            <h3>Reactive Strategies<br />
                                                Behaviours displayed in crisis include</h3>
                                        </header>
                                        <div className="rsContentBg p-3">
                                            {parseHTML(pbsPlansDetail?.reactiveStartegies)}
                                        </div>
                                    </div>
                                </div>

                                {/* Things to try when I am in crisis  */}
                                <div className="sectionWrapper">
                                    <div className="sectionContent pbsFieldWrapper">
                                        <header className="alert alert-dark cleanBg">
                                            <h3>Things to try when I am in crisis</h3>
                                        </header>
                                        <div className="cleanBg p-3">
                                            {parseHTML(pbsPlansDetail?.postThingsToTry)}
                                        </div>
                                    </div>
                                </div>

                                {/* Post Incident Support- Recovery */}
                                <div className="sectionWrapper">
                                    <div className="sectionContent pbsFieldWrapper">
                                        <header className="alert alert-dark pisrBg">
                                            <h3>Post Incident Support- Recovery</h3>
                                        </header>
                                        <div className="pisrContentBg p-3">
                                            {ReactHtmlParser(pbsPlansDetail?.postIncidentSupport)}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </PDFExport>
                    </div>
                </div>
            </Layout>
        </>
    );
}

export default ViewPbsPlansHistory;
